export default "__VITE_ASSET__BbeyvTtY__"